import React, {useMemo} from 'react';
import type {EBirdMyDataSchema} from "ebird-mydata-reader";
import {
    VISIT_HISTORY_EMPTY_LABEL,
    VISIT_HISTORY_HELPER
} from "./constants";
import {getVisitHistoryChartData} from "./helpers";
import './visit-history-chart.scss';

export type VisitHistoryChartProps = {
    observations: EBirdMyDataSchema[]
}

export function VisitHistoryChart({observations}: VisitHistoryChartProps) {
    const chartData = useMemo(() => getVisitHistoryChartData(observations), [observations]);
    const peakLabel = chartData.peakMonthsLabel ? `Peak Month: ${chartData.peakMonthsLabel}` : VISIT_HISTORY_EMPTY_LABEL;
    const helperLabel = chartData.peakCount > 0
        ? `${chartData.peakCount.toLocaleString()} visit${chartData.peakCount === 1 ? '' : 's'}`
        : VISIT_HISTORY_HELPER;

    return (
        <section className="hotspot-detail__monthly-visits" aria-label="Monthly visit summary">
            <div className="hotspot-detail__monthly-visits-header">
                <strong>{peakLabel}</strong>
                <p>{helperLabel}</p>
            </div>

            <div className="hotspot-detail__monthly-visits-chart" role="img" aria-label={`Monthly visit chart. Peak months: ${peakLabel}.`}>
                {chartData.months.map(month => (
                    <div
                        key={month.month}
                        className={`hotspot-detail__monthly-visits-month ${month.isPeak ? 'is-peak' : ''}`}
                    >
                        <div className="hotspot-detail__monthly-visits-bar-track">
                            {month.hasVisits ? (
                                <div
                                    className="hotspot-detail__monthly-visits-bar"
                                    style={{height: `${month.heightPercent}%`}}
                                    title={`${month.label}: ${month.count}`}
                                    aria-label={`${month.label}: ${month.count} visit${month.count === 1 ? '' : 's'}`}
                                />
                            ) : null}
                        </div>
                        <span className="hotspot-detail__monthly-visits-label">{month.label.charAt(0)}</span>
                    </div>
                ))}
            </div>
        </section>
    );
}
